export default __webpack_public_path__ + "static/media/NTEX CLASS-10 EXAM PATTERN 2025.3f1aada2.pdf";